export async function fetchCountryResidence({ commit }, params) {
  try {
    const { title } = (await this.$axios('/api/configs/countries', { params })).data;
    commit('setCountryResidence', title);
  } catch {
    commit('setCountryResidence', null);
  }
}
export default {
  fetchCountryResidence,
};
